// Core
import React from 'react';

// Component
import { SeriesChipProps } from './SeriesChip.types';
import {
  SeriesChipClose,
  SeriesChipColorDot,
  SeriesChipRoot,
} from './SeriesChip.style';

function SeriesChip({
  className,
  color,
  dotIcon,
  label,
  onRemove,
  removeAriaLabel,
  removeIcon,
  removeTestId,
  testId,
}: SeriesChipProps): JSX.Element {
  const dotTestId: string | undefined = testId ? `${testId}-dot` : undefined;

  return (
    <SeriesChipRoot className={className} data-testid={testId}>
      <SeriesChipColorDot color={color} data-testid={dotTestId}>
        {dotIcon}
      </SeriesChipColorDot>
      {label}
      {onRemove && (
        <SeriesChipClose
          aria-label={removeAriaLabel}
          data-testid={removeTestId}
          onClick={onRemove}
          type="button"
        >
          {removeIcon}
        </SeriesChipClose>
      )}
    </SeriesChipRoot>
  );
}

export { SeriesChip };
